import { render, staticRenderFns } from "./companyIntro.vue?vue&type=template&id=5c9d3753&scoped=true"
import script from "./companyIntro.vue?vue&type=script&lang=js"
export * from "./companyIntro.vue?vue&type=script&lang=js"
import style0 from "./companyIntro.vue?vue&type=style&index=0&id=5c9d3753&prod&lang=less&scoped=true"
import style1 from "./companyIntro.vue?vue&type=style&index=1&id=5c9d3753&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d3753",
  null
  
)

export default component.exports